import React from "react";
import useMedia from "react-use/lib/useMedia";
import { GoogleMap } from "./GoogleMap";
import styles from "../styles/Map.module.scss";
import { Marker } from "@react-google-maps/api";

export const Map = ({ data }: any) => {
  const isSmallScreen = useMedia("(max-width: 600px)");
  const height = isSmallScreen ? "330px" : "500px";
  const { location } = data;

  if (!location) {
    return null;
  }

  const [lat, lng]: [number, number] = location
    .split(",")
    .map((x: string) => parseInt(x));

  return (
    <section className={styles.mapWrapper}>
      <h3 className={styles.mapTitle}>
        <strong>Project location:</strong> {data.title}
      </h3>
      <GoogleMap containerStyle={{ width: "100%", height: height }}>
        <Marker position={{ lat, lng }}></Marker>
      </GoogleMap>
    </section>
  );
};
